import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useAuth } from "../context/AuthContext";
import * as api from "../api";

function DevenirExposant() {
  const { user } = useAuth();
  const [entreprise, setEntreprise] = useState("");
  const [wilaya, setWilaya] = useState("");
  const [categorieActivite, setCategorieActivite] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [abonnementExpire, setAbonnementExpire] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  if (!user) { navigate("/connexion"); return null; }
  if (user.role === "exposant" || user.role === "admin") {
    navigate("/mon-espace"); return null;
  }

  const wilayas = ["Alger","Oran","Béjaïa","Annaba","Jijel","Skikda","Tipaza","Mostaganem","Chlef","Aïn Témouchent"];
  const categories = ["Yachts & Voiliers","Bateaux à Moteur","Équipements & Electronique","Sports Nautiques","Services Maritimes","Construction Navale","Divers"];

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.upgradeExposant({ entreprise, wilaya, categorie_activite: categorieActivite });
      if (res.data.abonnement_expire_le) {
        const d = new Date(res.data.abonnement_expire_le);
        setAbonnementExpire(d.toLocaleDateString("fr-FR", { day: "2-digit", month: "long", year: "numeric" }));
      }
      setSubmitted(true);
      setTimeout(() => navigate("/mon-espace"), 4000);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = { width: "100%", padding: "12px 15px", border: "1px solid #e5e7eb", borderRadius: "8px", fontSize: "14px", outline: "none", boxSizing: "border-box" };
  const labelStyle = { display: "block", fontSize: "14px", fontWeight: "500", color: "#374151", marginBottom: "8px" };

  const avantages = [
    { title: "Publiez vos annonces", desc: "Ajoutez autant d'annonces que vous souhaitez avec photos et descriptions détaillées.", icon: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" },
    { title: "Visibilité maximale", desc: "Touchez des milliers de passionnés du secteur maritime en Algérie.", icon: "M15 12a3 3 0 11-6 0 3 3 0 016 0z M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" },
    { title: "Recevez des demandes", desc: "Accédez aux demandes de devis RFQ et répondez directement aux acheteurs.", icon: "M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" },
    { title: "Dashboard dédié", desc: "Gérez vos annonces, suivez vos statistiques et interactions depuis votre espace.", icon: "M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" }
  ];

  if (submitted) {
    return (
      <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
        <Navbar />
        <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <div style={{ textAlign: "center", padding: "60px" }}>
            <div style={{ width: "80px", height: "80px", borderRadius: "50%", backgroundColor: "#f0fdfa", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 20px" }}>
              <svg width="40" height="40" viewBox="0 0 24 24" fill="#0d9488">
                <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
              </svg>
            </div>
            <h2 style={{ fontSize: "24px", fontWeight: "700", color: "#1f2937", marginBottom: "10px" }}>Félicitations ! 🎉</h2>
            <p style={{ color: "#6b7280" }}>Votre compte Exposant est activé. Un email de confirmation vous a été envoyé.</p>
            {abonnementExpire && (
              <div style={{ marginTop: "16px", backgroundColor: "#f0fdfa", border: "1px solid #99f6e4", borderRadius: "10px", padding: "16px", display: "inline-block" }}>
                <p style={{ margin: 0, fontSize: "14px", color: "#0f766e" }}>
                  <strong>✅ Abonnement actif</strong><br />
                  <span style={{ fontSize: "13px" }}>Date de fin : <strong>{abonnementExpire}</strong></span>
                </p>
              </div>
            )}
            <p style={{ color: "#9ca3af", fontSize: "13px", marginTop: "12px" }}>Redirection en cours...</p>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <Navbar />
      <div style={{ flex: 1, backgroundColor: "#f9fafb", padding: "60px 50px" }}>
        <div style={{ maxWidth: "1000px", margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: "50px" }}>
            <span style={{ display: "inline-block", backgroundColor: "#f0fdfa", color: "#0d9488", padding: "6px 16px", borderRadius: "20px", fontSize: "13px", fontWeight: "600", marginBottom: "16px" }}>
              Gratuit et sans engagement
            </span>
            <h1 style={{ fontSize: "38px", fontWeight: "700", color: "#1f2937", marginBottom: "15px" }}>
              Devenez Exposant sur <span style={{ color: "#0d9488" }}>MarinaDZ</span>
            </h1>
            <p style={{ fontSize: "18px", color: "#6b7280", maxWidth: "600px", margin: "0 auto" }}>
              Rejoignez notre réseau de professionnels du secteur maritime et développez votre activité en Algérie.
            </p>
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "20px", marginBottom: "50px" }}>
            {avantages.map((av, i) => (
              <div key={i} style={{ backgroundColor: "white", borderRadius: "12px", padding: "24px", boxShadow: "0 1px 3px rgba(0,0,0,0.1)", display: "flex", gap: "16px" }}>
                <div style={{ width: "48px", height: "48px", borderRadius: "12px", backgroundColor: "#f0fdfa", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#0d9488" strokeWidth="2"><path d={av.icon}/></svg>
                </div>
                <div>
                  <h3 style={{ fontSize: "15px", fontWeight: "600", color: "#1f2937", marginBottom: "6px" }}>{av.title}</h3>
                  <p style={{ fontSize: "13px", color: "#6b7280", lineHeight: "1.5" }}>{av.desc}</p>
                </div>
              </div>
            ))}
          </div>

          <div style={{ backgroundColor: "white", borderRadius: "16px", padding: "40px", boxShadow: "0 1px 3px rgba(0,0,0,0.1)", maxWidth: "500px", margin: "0 auto" }}>
            <h2 style={{ fontSize: "20px", fontWeight: "700", color: "#1f2937", marginBottom: "8px" }}>Finaliser mon compte Exposant</h2>
            <p style={{ fontSize: "14px", color: "#6b7280", marginBottom: "24px" }}>
              Connecté en tant que <strong>{user.prenom} {user.nom}</strong>
            </p>
            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: "24px" }}>
                <label style={labelStyle}>Nom de votre entreprise / activité *</label>
                <input type="text" value={entreprise} onChange={(e) => setEntreprise(e.target.value)}
                  placeholder="Ex: Marine Pro, Nautic Services DZ..." required style={inputStyle} />
              </div>
              <div style={{ marginBottom: "24px" }}>
                <label style={labelStyle}>Wilaya *</label>
                <select value={wilaya} onChange={e => setWilaya(e.target.value)} required style={inputStyle}>
                  <option value="">Sélectionner...</option>
                  {wilayas.map(w => <option key={w} value={w}>{w}</option>)}
                </select>
              </div>
              <div style={{ marginBottom: "24px" }}>
                <label style={labelStyle}>Catégorie d'activité *</label>
                <select value={categorieActivite} onChange={e => setCategorieActivite(e.target.value)} required style={inputStyle}>
                  <option value="">Sélectionner...</option>
                  {categories.map(c => <option key={c} value={c}>{c}</option>)}
                </select>
              </div>
              <button type="submit" disabled={loading} style={{ width: "100%", padding: "14px", backgroundColor: loading ? "#9ca3af" : "#0d9488", color: "white", border: "none", borderRadius: "8px", fontSize: "15px", fontWeight: "600", cursor: loading ? "not-allowed" : "pointer" }}>
                {loading ? "Activation en cours..." : "Activer mon compte Exposant →"}
              </button>
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default DevenirExposant;